import { Outlet, useParams } from 'react-router-dom';
import { useClientConfig } from '@/hooks/useClients';

export function ClientLayout() {
  const { clientId } = useParams();
  const { data: clientConfig, isLoading } = useClientConfig(clientId);

  // Pass client context down through Outlet context if needed
  return (
    <div className="min-h-[calc(100vh-4rem)]">
      <Outlet context={{ clientConfig, clientId, isLoading }} />
    </div>
  );
}
